var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavAjustes = function SvgNavAjustes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nav_ajustes_svg__Capa_2",
    viewBox: "0 0 31.28 33.93"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nav_ajustes_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.59 21.92V12c0-2.27-1.21-4.38-3.18-5.51l-8.59-4.95a6.36 6.36 0 0 0-6.37 0L3.87 6.5a6.37 6.37 0 0 0-3.18 5.51v9.92c0 2.27 1.21 4.38 3.18 5.51l8.59 4.96a6.36 6.36 0 0 0 6.37 0l8.59-4.96a6.37 6.37 0 0 0 3.18-5.51Z",
    fill: "none",
    stroke: "#b3b3b3",
    strokeLinecap: "round",
    strokeWidth: "1.37px"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.64,
    cy: 16.86,
    r: 5.6,
    stroke: "#19d3c5",
    strokeWidth: "1.5px",
    fill: "none"
  }))));
};
export default SvgNavAjustes;